import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface WhiteListQueryParams {
  key_word: string // 关键词搜索
  page: number // 页码
  limit: number // 每页数量
}

export interface WhiteListItem {
  /** 启动项hash */
  autorun_hash: string
  /** 启动项名称 */
  soft_name: string
  /** 启动项类型 */
  autorun_type: number
  autorun_name: string
  autorun_desc: string
}

@Injectable()
export class WhiteListViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchWhiteList (options: WhiteListQueryParams) {
    return this.http
      .post<{
        total: number,
        list: WhiteListItem[]
      }>('terminal/start-item/trust-list', options)
  }
  // 取消信任项--待确认
  // @InvokeThrottle()
  // cancelWhiteListItem (options: WhiteListQueryParams) {
  //   return this.http
  //     .post<{
  //       total: number,
  //       list: WhiteListItem[]
  //     }>('terminal/start-item/trust-list', options)
  // }
}
